const slugify = (str) => {
    str = str.replace(/^\s+|\s+$/g, '');

    // Make the string lowercase
    str = str.toLowerCase();

    // Remove accents, swap ñ for n, etc
    var from = 'ĄÁÄÂÀÃÅČÇĆĎĘÉĚËÈÊẼĔȆÍÌÎÏŁŃŇÑÓÖÒÔÕØŘŔŚŠŤÚŮÜÙÛÝŸŻŹŽąáäâàãåčçćďęéěëèêẽĕȇíìîïłńňñóöòôõøðřŕśšťúůüùûýÿżźžþÞĐđßÆa·/_,:;';
    var to = 'AAAAAAACCCDEEEEEEEEEIIIILNNNOOOOOORRSSTUUUUUYYZZZaaaaaaacccdeeeeeeeeeiiiilnnnooooooorrsstuuuuuyyzzzbBDdBAa------';
    for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    // Remove invalid chars
    str = str.replace(/[^a-z0-9 -]/g, '')
        // Collapse whitespace and replace by -
        .replace(/\s+/g, '-')
        // Collapse dashes
        .replace(/-+/g, '-');

    return str;
};

export default slugify;